import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NotifyModel } from 'Modules'

type State = {
	notification: NotifyModel
}

const initialState: State = {
	notification: null,
}

export namespace NotifyNS {
	export type ShowNotify = PayloadAction<NotifyModel>
	export type RemoveNotify = PayloadAction
	export type SetNotify = PayloadAction<NotifyModel>
}

export const notifySlice = createSlice({
	name: 'notify',
	initialState,
	reducers: {
		showNotify: (state, action: NotifyNS.ShowNotify) => {},
		setNotify: (state, action: NotifyNS.SetNotify) => {
			state.notification = action.payload
		},
		removeNotify: (state, action: NotifyNS.RemoveNotify) => {
			state.notification = null
		},
	},
})
